export const GET_DATA = 'GET_DATA_MONITORING';
export const UPDATE_ROW_DATA = 'UPDATE_ROW_DATA_MONITORING';
export const GET_DATA_ERROR = 'GET_DATA_MONITORING_ERROR'
export const CHANGE_DATE = 'CHANGE_DATE_MONITORING';
export const CHANGE_OPTION = 'CHANGE_OPTION_MONITORING';
export const SAVE_DATA = 'SAVE_DATA_MONITORING';


